/* eslint-disable max-lines */
import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import Loader from 'react-simple-loading';

import callApi from '../../utils/callApi';
import {
  CHECK_PROMOTION_AVAILABLE_FOR_USER,
  FETCH_GENERATED_USERNAME,
  LIST_EPAY_NAKEDNEWS_FANCLUB,
  LIST_EPAY_PACKAGES,
  LIST_ALL_EPAY_PRICES_FANCLUB,
  STATUS_URL,
  GET_PRODUCTS,
} from '../../constants/apiUrls/apiUrls';
import { PROMO_CODES } from '../../constants/promoCodes';
import MaintainenceImage from '../../assets/maintainence.jpg';
import nnliveImage2 from '../../assets/createAccountPage/nn-banner-checkout-left.png';
import { getCookie } from '../../utils/helpers';
import './css/CreateAccount.css';
import '../../css/utils/flex.css';
import IsabellaPaymentImage from '../../assets/createAccountPage/Alana-main-payment.png';
import MarinaPaymentImage from '../../assets/createAccountPage/marina-main-payment.png';
import NotificationStore from '../../store/NotificationStore';
import AccountPackages from '../../components/accountComponents/AccountPackages';
import CampaignStore from '../../store/CampaignStore';
import PayPerViewStore from '../../store/PayPerViewStore';

import { getAnchorImage, getRandomImage } from './createAccountImages';
import FanzoneSubscription from './FanzoneSubscription';
import CheckoutFooter from './CheckoutFooter';
import CheckoutHeader from './CheckoutHeader';


const NAKED_NEWS_LIVE_ID = 241;


@observer
class CreateAccountPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      programs: [],
      anchorSubscriptionPrograms: [],
      paymentPackages: [],
      isLoading: true,
      createdUser: '',
      token: '',
      showPromoInput: false,
      feeIsAdded: false,
      promoInUrl: {},
      isCampaignActive: false,
    };

    const urlParams = new URLSearchParams(window.location.search);
    this.anchorToSubscribe = urlParams.get('_anchor');
    this.disableOneClickPaysafe = urlParams.get('_disableOneClickPaysafe');
    this.amountParam = urlParams.get('_amount');
    this.shortUrlParam = urlParams.get('_shortUrl');
    this.code = urlParams.get('code');
    this.promoCode = urlParams.get('promoCode')?.toUpperCase();
    this.promoHash = urlParams.get('promoHash');
    this.campaignSource = urlParams.get('campaign');

    // enable in case of Paysafe problems
    // this.paymentWhitelisted = user && user.features && user.features.includes('ENABLE_PAYMENT');
    this.paymentWhitelisted = true;

    this.createAccountImage = this.anchorToSubscribe ? getAnchorImage(this.anchorToSubscribe) : getRandomImage();
  }

  setPromoInUrl = (hash, affiliateCode) => {
    this.setState({
      promoInUrl: {
        hash,
        affiliateCode,
      },
    });
  };

  getDataForCampaign = async(promoCode) => {
    const { user, isAccountCreationPage, listOfActiveCampaigns, isMrSkinPromoPage } = this.props;
    const { currentCampaign } = CampaignStore;
    const promoPage = (
      isMrSkinPromoPage ||
      window.location.pathname === '/promo/asn-awards'
    );
    const NNLivePromoPage = window.location.pathname === '/nnl-promo-card';
    const NNPromoPage = window.location.pathname === '/nn-promo-card';
    const data = {};
    const isMembershipCheckout = this.isMembershipCheckoutPage();
    const isCampaignActive = isMrSkinPromoPage ||
      (currentCampaign.affiliateCode &&
        isMembershipCheckout) && currentCampaign?.affiliateCode !== PROMO_CODES.CYBERMONDAY23;
    this.setState({ isCampaignActive });

    if (isAccountCreationPage) {
      this.setState({ showPromoInput: true });
    }

    if (user.authenticated) {
      const { username, token } = user?.user || {};
      data.token = token || sessionStorage.getItem('token');
      data.userName = username;
    }

    if (isCampaignActive) {
      data.affiliateCode = currentCampaign.affiliateCode;
      data.pcode = currentCampaign.pcode;
    }

    if ((isAccountCreationPage && !isCampaignActive)) {
      delete data.affiliateCode;
      delete data.pcode;
    }

    if ((currentCampaign.affiliateCode && !isMrSkinPromoPage) || (isMrSkinPromoPage && promoPage)) {
      data.affiliateCode = currentCampaign.affiliateCode;
      data.pcode = currentCampaign.pcode;
    }

    if (NNLivePromoPage) {
      data.affiliateCode = 'nnlpromo20220505';
    }

    if (NNPromoPage) {
      data.affiliateCode = 'nnpromo20220505';
    }

    if (promoCode && isAccountCreationPage) {
      data.affiliateCode = promoCode;
      data.pcode = promoCode;
    }

    const campaignExists = listOfActiveCampaigns?.find((campaign) => campaign?.affiliateCode === this.promoCode);

    if (this.promoCode?.length && campaignExists) {
      data.affiliateCode = this.promoCode;
      data.pcode = this.promoCode;
      this.setPromoInUrl(null, this.promoCode);
    }

    if (this.promoHash?.length) {
      const res = await this.checkIfUserHasPromotion(this.promoHash, true);
      if (res.status === 200 && res.data === 'OK') {
        data.affiliateCode = PROMO_CODES.FREESIGNUP15;
        data.pcode = PROMO_CODES.FREESIGNUP15;
        this.setPromoInUrl(this.promoHash, data.affiliateCode);
      } else {
        NotificationStore.error('This link is no longer valid.');
      }
    }

    return data;
  };

  fetchPaymentPackages = (data) => {
    callApi(LIST_EPAY_PACKAGES, 'get', data, {}, {}, false).
      then((res) => res.data.products).
      catch(() => NotificationStore.error('Error getting packages. Please try again'));
  };

  handleCam4AffiliateMembership = (data) => {
    const { user } = this.props;

    if (!user.authenticated) {
      this.fetchUserName().
        then((usernameRes) => {
          const { username } = usernameRes.data;
          this.setState({ createdUser: username });
          data.userName = username;
          callApi(STATUS_URL, 'get', {}, {}, {}, true, true).
            then((res) => {
              if (res.data.user) {
                const { token } = res.data.user;
                this.setState({ token });
                data.token = token;
              } else {
                document.cookie = `_atc=${PROMO_CODES.CAM4_SOURCE}; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
                window.location = '/account/purchase';
              }
              this.fetchPaymentPackages(data);
            }).
            catch((e) => console.error(e));
        }).
        catch((e) => console.error(e));
    }
  };

  formatProductDataObject = (products, epayData) => {
    const formattedProducts = [...products];

    formattedProducts.forEach((product) => {
      product.priceId = epayData?.[0]?.id;
      product.currency = epayData?.[0]?.currency;
      product.categories = epayData?.[0]?.categories;
      product.details.trialPeriod = product?.details?.initialPeriod;
      product.details.trialUnit = product?.details?.initialPeriodUnit;
      product.details.recurringPeriodType = product?.details?.recurringPeriodUnit;
    });

    return formattedProducts;
  };

  getProductsUrl = (packageType) => GET_PRODUCTS.replace('{productType}', packageType);

  // eslint-disable-next-line complexity
  fetchPackages = async(promoCode, pcode) => {
    const affiliateCode = getCookie('_atc');
    const data = await this.getDataForCampaign(promoCode, pcode);

    if (affiliateCode === PROMO_CODES.CAM4_SOURCE) {
      this.handleCam4AffiliateMembership(data);

      return;
    }

    const NNLivePromoPage = window.location.pathname === '/nnl-promo-card';
    const url = NNLivePromoPage ? LIST_EPAY_NAKEDNEWS_FANCLUB : LIST_EPAY_PACKAGES;

    callApi(url, 'get', data, {}, {}, false).
      then((res) => {
        if (res.data.reason) {
          this.redirectToHome();

          return;
        }
        const allProducts = res.data.products;
        if (res.data.products[0].details?.fee > 0) {
          this.setState({ feeIsAdded: true });
        }

        let staticProducts = allProducts?.filter((product) => !product?.details?.max);
        if (!staticProducts?.length) {
          staticProducts = allProducts;
        }

        this.setState({
          programs: staticProducts,
          isLoading: false,
        });
      }).
      catch(() => NotificationStore.error('Error getting packages. Please try again'));
  };

  fetchUserName = () => callApi(
    FETCH_GENERATED_USERNAME,
    'post',
    {},
    {},
    { 'content-type': 'application/json; charset=utf-8' },
    false
  );

  checkIfUserHasPromotion = (hash, hasLimitedValidity) => {
    let URL = CHECK_PROMOTION_AVAILABLE_FOR_USER;

    if (hasLimitedValidity) {
      URL += '/verify';
    }

    return callApi(URL, 'GET', { hash });
  };

  checkIfProductExists = (filteredProductsArray, allProducts) => {
    if (!filteredProductsArray.length || !filteredProductsArray?.[0]) {
      return allProducts?.data?.products.slice(0, 1);
    }

    return filteredProductsArray;
  };

  campaignIsLaunched = (affiliateCode) => {
    const { user } = this.props;

    return user?.features?.includes(affiliateCode);
  };

  getFanclubCampaignProductCode = () => {
    if (this.campaignSource === PROMO_CODES.CHRISTMAS_FANZONE_2023 &&
        CampaignStore.findCampaignByCode(PROMO_CODES.CHRISTMAS_FANZONE_2023)) {
      return PROMO_CODES.CHRISTMAS_FANZONE_2023;
    }

    return PROMO_CODES.TRIALFANCLUBS2023.toLocaleLowerCase();
  };

  fetchAnchorSubscriptionPackages = async(promoCode, pcode) => {
    const { user, anchorPortalCampaign } = this.props;
    const { currentCampaign } = CampaignStore;
    const atc = getCookie('_atc');
    const data = {};
    const isFanzoneCheckout = this.anchorToSubscribe?.length;
    let queryParams = {};

    if (isFanzoneCheckout) {
      this.setState({ showPromoInput: true });
    }

    if (currentCampaign?.affiliateCode === PROMO_CODES.CYBERMONDAY23) {
      data.affiliateCode = PROMO_CODES.CYBERMONDAY2022;
      data.pcode = PROMO_CODES.CYBERMONDAY23;
    }

    if (this.code) {
      try {
        const res = await this.checkIfUserHasPromotion(this.code, false);
        if (res.status === 200 && res.data === 'OK') {
          const codeForEPay = this.getFanclubCampaignProductCode();
          data.affiliateCode = codeForEPay;
          this.setPromoInUrl(this.code, data.affiliateCode);
        }
      } catch {
        console.error('No Promotion available');
      }
    }

    if (user.authenticated) {
      data.token = sessionStorage.getItem('token');
      data.userName = user.user.username;
    }

    if (promoCode) {
      data.affiliateCode = promoCode;
    }

    if (this.promoCode?.length) {
      data.affiliateCode = this.promoCode;
      this.setPromoInUrl(null, this.promoCode);
    }

    if (
      (atc === PROMO_CODES.CAM4_ANCHOR_SOURCE || atc === PROMO_CODES.PROMO_ANCHOR_SOURCE) &&
      anchorPortalCampaign.anchorPortal) {
      data.affiliateCode = anchorPortalCampaign.affiliateCode;
    }


    if (parseInt(this.anchorToSubscribe, 10) === NAKED_NEWS_LIVE_ID &&
      this.campaignIsLaunched(PROMO_CODES.CYBERMONDAY23) && currentCampaign?.affiliateCode === PROMO_CODES.CYBERMONDAY23) {
      this.setState({ isCampaignActive: true });
    }

    const epayPricesURL = LIST_ALL_EPAY_PRICES_FANCLUB;
    const url = this.getProductsUrl('FANCLUB');
    callApi(epayPricesURL, 'get', { token: data.token, userName: data.userName }, {}, {}, false).
      then((pricesRes) => {
        if (pricesRes.data.reason) {
          this.redirectToHome();

          return;
        }
        queryParams = { affiliateCode: data?.affiliateCode, anchorId: this.anchorToSubscribe };
        callApi(url, 'get', queryParams).
          then((res) => {
            const { data: pricesData } = res;
            let anchorSubProduct = [];
            anchorSubProduct = this.formatProductDataObject(pricesData?.products, pricesRes?.data?.products);

            this.setState({
              paymentPackages: pricesRes.data.products || [],
              anchorSubscriptionPrograms: anchorSubProduct,
              isLoading: false,
              feeIsAdded: anchorSubProduct?.[0]?.details?.fee > 0,
            });
          });
      }).
      catch((e) => console.error(e));
  };

  redirectToHome() {
    window.location.href = '/';
  }

  componentDidMount() {
    CampaignStore.setCampaignByPage(window.location.pathname + window.location.search, this.anchorToSubscribe);
    if (this.anchorToSubscribe) {
      this.paymentWhitelisted && this.fetchAnchorSubscriptionPackages();
    } else {
      this.paymentWhitelisted && this.fetchPackages();
    }

    if (document.getElementById('navigation')) {
      document.getElementById('navigation').style.display = 'none';
    }
    if (document.getElementsByClassName('footer').length) {
      document.getElementsByClassName('footer')[0].style.display = 'none';
    }
  }

  componentWillUnmount() {
    document.getElementById('navigation').style.display = '';
    PayPerViewStore.setPaymentLoading(false);
  }

  displayUnavailableMessage() {
    return (
      <div className="unavailable-container" style={{ width: '100%', height: '100vh' }}>
        <div className="container" style={{ height: '100%' }}>
          <div className="unavailable-message">
            <img
              alt="maintainence" src={MaintainenceImage} style={{
                width: '100%',
                maxWidth: '420px',
                margin: '0 0 30px',
                border: '0',
              }}
            />
            <h3>Sorry! Account creation is unavailable for the moment.</h3>
            <p style={{ fontSize: '20px' }}>We are working to get it working as soon as possible!</p>
            <button
              className="btn btn-primary caps montserrat package-button"
              style={{ marginTop: '20px' }}
              onClick={this.redirectToHome}
            >
              Return
            </button>
          </div>
        </div>
      </div>
    );
  }

  needToBeInvisible = () => [
    '/promo/asn-awards',
    '/lifetime-promo-live',
    '/account/purchase',
    // new pages that we would like to have invisible
  ].includes(window.location.pathname + window.location.search);

  isMembershipCheckoutPage = () => window.location.pathname.includes('/account/purchase') && !this.anchorToSubscribe;

  getActiveCampaign = (activeCampaign) => {
    if (parseInt(this.anchorToSubscribe, 10) !== NAKED_NEWS_LIVE_ID && activeCampaign?.affiliateCode === PROMO_CODES.CYBERMONDAY23) {
      return {};
    }

    return activeCampaign;
  };

  render() {
    const { user, anchorPortalCampaign, listOfActiveCampaigns, isMrSkinPromoPage } = this.props;
    const { currentCampaign: activeCampaign } = CampaignStore;
    const { paymentPackages, programs, isLoading, anchorSubscriptionPrograms, showPromoInput, feeIsAdded, promoInUrl, isCampaignActive } = this.state;
    const currentCampaign = this.getActiveCampaign(activeCampaign);
    const { affiliateCode, checkoutImage } = currentCampaign || {};
    const NNLivePromoPage = window.location.pathname === '/nnl-promo-card';
    const NNPromoPage = window.location.pathname === '/nn-promo-card';
    const ASNMagazineCampaign = window.location.pathname === '/promo/asn-awards';
    const isASNAW22 = ASNMagazineCampaign && affiliateCode === PROMO_CODES.ASNAW22;

    let anchorAccountImage = this.createAccountImage.anchorImage;
    if (isMrSkinPromoPage || isASNAW22) {
      anchorAccountImage = nnliveImage2;
    }

    if (!this.paymentWhitelisted) {
      return this.displayUnavailableMessage();
    }

    const useMembershipLayout = this.isMembershipCheckoutPage() || (this.anchorToSubscribe && isCampaignActive);
    const isInvisible = this.needToBeInvisible() || isCampaignActive || useMembershipLayout;
    const backgroundImage = `url(${checkoutImage})`;
    let anchorLeftImage = useMembershipLayout ? MarinaPaymentImage : anchorAccountImage;
    anchorLeftImage = isCampaignActive && !isMrSkinPromoPage ? null : anchorLeftImage;
    const anchorRightImage = isCampaignActive ? null : IsabellaPaymentImage;

    return (
      <div
        className="create-account-container"
        id={classnames({ ASNMagazineCampaign })}
      >
        <CheckoutHeader activeCampaign={activeCampaign} anchorToSubscribe={this.anchorToSubscribe} />
        {PayPerViewStore.paymentLoading &&
          <div className="payment-loading-overlay">
            <Loader />
          </div>}
        <div
          className={classnames(
            'purchaseIndexViewWrapper', {
              'mr-skin-promo': isMrSkinPromoPage,
              'membership-checkout': useMembershipLayout || isCampaignActive,
              'force-background-color': isCampaignActive,
              [`${activeCampaign?.affiliateCode}`]: activeCampaign?.affiliateCode !== null,
            })}
          id="purchaseIndexViewContainer"
          style={{ backgroundImage }}
        >
          {!isLoading &&
            <div id="purchaseIndexView">
              <div
                className={classnames('content', { 'package-invisible': isInvisible })}
              >
                <div className="container">
                  <div className="row-r" id="join_header">
                    {
                      this.anchorToSubscribe ? (
                        <FanzoneSubscription
                          activeCampaign={activeCampaign}
                          amountParam={this.amountParam}
                          anchorLeftImage={anchorLeftImage}
                          anchorPortalCampaign={anchorPortalCampaign}
                          anchorRightImage={anchorRightImage}
                          anchorShortUrl={this.shortUrlParam}
                          anchorSubscriptionPrograms={anchorSubscriptionPrograms}
                          anchorToSubscribe={this.anchorToSubscribe}
                          createAccountImage={this.createAccountImage}
                          createdUser={this.state.createdUser}
                          disableOneClickPaysafe={this.disableOneClickPaysafe}
                          feeIsAdded={feeIsAdded}
                          fetchPackages={this.fetchAnchorSubscriptionPackages}
                          hasPromoInURL={promoInUrl}
                          isCampaignActive={isCampaignActive}
                          isInvisible={isInvisible}
                          isMembershipCheckoutPage={useMembershipLayout}
                          listOfActiveCampaigns={listOfActiveCampaigns}
                          showPromoInput={showPromoInput}
                          token={this.state.token}
                          user={user}
                          isMrSkinPromoPage={isMrSkinPromoPage}
                        />
                      ) : (
                        <>
                          <div
                            className={classnames(
                              'col-sm-12',
                              'col-xs-12',
                              'accounts-right-image',
                              {
                                'col-md-6': !useMembershipLayout,
                                'col-md-3': useMembershipLayout,
                              })}
                            style={{ textAlign: 'right' }}
                          >
                            <img alt="" src={anchorLeftImage} />
                          </div>
                          <div
                            className={classnames(
                              'col-sm-12',
                              'col-xs-12',
                              'account-left-section',
                              {
                                'col-md-6': !useMembershipLayout,
                                'col-md-3': useMembershipLayout,
                              })}
                          >
                            <AccountPackages
                              NNLivePromoPage={NNLivePromoPage}
                              NNPromoPage={NNPromoPage}
                              activeCampaign={activeCampaign}
                              amountParam={this.amountParam}
                              createdUser={this.state.createdUser}
                              disableOneClickPaysafe={this.disableOneClickPaysafe}
                              feeIsAdded={feeIsAdded}
                              fetchPackages={this.fetchPackages}
                              hasPromoInURL={promoInUrl}
                              isCampaignActive={isCampaignActive}
                              isInvisible={isInvisible}
                              isMembershipPaymentPage={useMembershipLayout}
                              listOfActiveCampaigns={listOfActiveCampaigns}
                              paymentPackages={paymentPackages}
                              programs={programs}
                              showPromoInput={showPromoInput}
                              token={this.state.token}
                              user={user}
                              isMrSkinPromoPage={isMrSkinPromoPage}
                            />
                          </div>
                          <div
                            className={classnames(
                              'col-sm-12',
                              'col-xs-12',
                              'accounts-right-image',
                              'image-right',
                              {
                                'col-md-6 hide': !useMembershipLayout,
                                'col-md-3': useMembershipLayout,
                              })}
                            style={{ textAlign: 'right' }}
                          >
                            <img alt="" src={anchorRightImage} />
                          </div>
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <CheckoutFooter />
      </div>
    );
  }
}

export default CreateAccountPage;

CreateAccountPage.defaultProps = { isMrSkinPromoPage: false };
